import React, { useState } from "react";
import Popover from "../../components/ui/Popover";
import Icon from "../../components/ui/Icon";

// Show, hide and reorder the table's columns. Rows drag to reorder; the
// arrow buttons do the same from the keyboard.
export default function ColumnPicker({ columns, trigger, triggerClass = "btn", label }) {
  const { ordered, hidden, setVisible, move, showAll, reset, pinned } = columns;
  const [dragKey, setDragKey] = useState(null);
  const [overKey, setOverKey] = useState(null);

  const movable = ordered.filter((f) => f.key !== pinned);
  const shown = ordered.length - hidden.length;

  return (
    <Popover align="right" triggerClass={triggerClass} label={label} trigger={trigger}>
      <div className="colpick">
        <div className="colpick-head">
          <span>
            {shown} of {ordered.length} columns
          </span>
          <span className="colpick-links">
            {hidden.length > 0 && (
              <button type="button" className="btn-link" onClick={showAll}>
                Show all
              </button>
            )}
            <button type="button" className="btn-link" onClick={reset}>
              Reset
            </button>
          </span>
        </div>

        <ul className="colpick-list">
          <li className="colpick-item is-pinned" title="Always shown">
            <span className="colpick-grip" />
            <input type="checkbox" checked disabled aria-label="Channel name (always shown)" />
            <span className="colpick-name">{ordered[0].label}</span>
            <span className="colpick-note">always</span>
          </li>

          {movable.map((field, i) => {
            const on = !hidden.includes(field.key);
            return (
              <li
                key={field.key}
                className={`colpick-item${dragKey === field.key ? " is-dragging" : ""}${
                  overKey === field.key && dragKey !== field.key ? " is-over" : ""
                }`}
                draggable
                onDragStart={(e) => {
                  setDragKey(field.key);
                  e.dataTransfer.effectAllowed = "move";
                }}
                onDragOver={(e) => {
                  e.preventDefault();
                  setOverKey(field.key);
                }}
                onDrop={(e) => {
                  e.preventDefault();
                  if (dragKey) move(dragKey, field.key);
                  setDragKey(null);
                  setOverKey(null);
                }}
                onDragEnd={() => {
                  setDragKey(null);
                  setOverKey(null);
                }}
              >
                <span className="colpick-grip" aria-hidden="true">
                  ⋮⋮
                </span>
                <input
                  type="checkbox"
                  id={`col-${field.key}`}
                  checked={on}
                  onChange={() => setVisible(field.key, !on)}
                />
                <label htmlFor={`col-${field.key}`} className={`colpick-name${on ? "" : " is-off"}`}>
                  {field.label}
                </label>
                <span className="colpick-arrows">
                  <button
                    type="button"
                    className="icon-btn"
                    aria-label={`Move ${field.label} up`}
                    disabled={i === 0}
                    onClick={() => move(field.key, movable[i - 1].key)}
                  >
                    <Icon name="up" size={14} />
                  </button>
                  <button
                    type="button"
                    className="icon-btn"
                    aria-label={`Move ${field.label} down`}
                    disabled={i === movable.length - 1}
                    onClick={() => move(field.key, movable[i + 1].key)}
                  >
                    <Icon name="down" size={14} />
                  </button>
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    </Popover>
  );
}
